<template>
    <div id="chart" class="wrapper-chart">
      <h3>Tempo Médio de Espera por Fila (Telefonia)</h3>
      <apexchart
        ref="chart_ref"
        type="bar"
        height="280"
        :options="chartOptions"
        :series="series"
      />
    </div>
  </template>
  
  <script>
  import axios from 'axios'
  import moment from 'moment'
  import momentDuration from 'moment-duration-format'
  momentDuration(moment)
  
  export default {
    props: {
      type: { type: String, required: false, default: 'waitingTime' }, // não alterna mais
      filter: {
        type: Object,
        required: true,
        default: () => ({
          startDate: moment().format('YYYY-MM-DD 00:00:00'),
          endDate: moment().format('YYYY-MM-DD 23:59:59'),
          queue: '*'
        })
      },
      plot_options: { type: String, required: false }, 
      yaxis: { type: String, required: false }, 
    },
    data () {
      return {
        series: [{ data: [] }],
        chartOptions: {
          chart: { type: 'bar', height: 220 },
          plotOptions: this.plot_options ?? {
            bar: {
              barHeight: '100%',
              distributed: true,
              horizontal: false, // << agora em pé
              dataLabels: { position: 'top' }
            }
          },
          dataLabels: { enabled: false },
          xaxis: {
            categories: [] // << nomes das filas no eixo X
          },
          yaxis: this.yaxis ?? {
            labels: {
              formatter: (value) => this.formatDuration(value) // << formatação no eixo Y
            }
          },
          tooltip: {
            y: {
              formatter: (value) => this.formatDuration(value),
              title: { formatter: () => 'Tempo Médio: ' }
            }
          },
          noData: { text: 'Sem dados para exibir no momento...' },
          colors: ['#008FFB', '#FEB019', '#00E396', '#FF4560', '#ffd60a', '#775DD0', '#7f4f24', '#00f5d4', '#4d194d', '#333533'] // paleta do waitingTime
        }
      }
    },
    methods: {
      formatDuration (sec) {
        return sec >= 86400
          ? moment.duration(sec, 'seconds').format('hh:mm:ss').replace(',', '.')
          : moment.utc(sec * 1000).format('HH:mm:ss')
      },
      getCallsAverage () {
        if (!this.filter.startDate || !this.filter.endDate) return
  
        // << sempre busca o TEMPO DE ESPERA
        const urlPath = 'dashboard/averageWaitingTimeReport'
  
        const params = new URLSearchParams({
          startDate: this.filter.startDate,
          endDate: this.filter.endDate,
          queue: this.filter.queue || '*'
        })
  
        axios.get(`${urlPath}?${params.toString()}`)
          .then(({ data }) => {
            const sorted = (data || []).slice().sort((a, b) => (b.average ?? 0) - (a.average ?? 0))
            this.chartOptions.xaxis.categories = sorted.map(el => el.queuename.toUpperCase())
            this.series[0].data = sorted.map(el => el.average)
            this.$refs.chart_ref.refresh()
          })
          .catch(err => console.error('Erro ao buscar tempo médio:', err))
      }
    },
    watch: {
      filter: {
        deep: true,
        immediate: true,
        handler () { this.getCallsAverage() }
      }
    }
  }
  </script>
  
  <style scoped>
  .wrapper-chart { width: 65%; margin: 20px auto; }
  </style>
  